import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap";

// Connects to data-controller="close-modal"
export default class extends Controller {
  connect() {
    document.addEventListener('turbo:submit-end', this.handleSubmit)
  }

  disconnect() {
    document.removeEventListener('turbo:submit-end', this.handleSubmit)
  }

  handleSubmit = (e) => {
    if (e.detail.success) {
      Modal.getOrCreateInstance(this.element).hide()
    }
  }
}
